/*
 * @Author: your name
 * @Date: 2021-04-14 15:33:39
 * @LastEditTime: 2021-04-15 10:24:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/blogger/api.js
 */
import request from '@/router/axios';


//新增博主
export function bloggerSave(query) {
  return request({
    url: '/api/blogger/save',
    method: 'post',
    data: query
  })
}

//查看博主列表
export function bloggerPageList(query) {
    return request({
      url: '/api/blogger/page',
      method: 'get',
      params: query
    })
  }
//id查询博主
export function bloggerDetail(query) {
  return request({
    url: '/api/blogger/detail',
    method: 'get',
    params: query
  })
}


//校验博主名称
export function bloggerNameCheck(query) {
  return request({
    url: '/api/blogger/check/bloggerName',
    method: 'get',
    params: query
  })
}

//查询博主审核详情
export function bloggerAuditDetail(query) {
  return request({
    url: '/api/blogger/audit/detail',
    method: 'get',
    params: query
  })
}



